import { create } from "zustand";
import { persist } from "zustand/middleware";
import { createSessionStoragePersist } from "../utils/sessionStoragePersist";

export interface Profile {
  id: number;
  user_id: number;
  name: string;
  dob: string;
  sex: "male" | "female";
  city: string;
  country_code: string;
  timezone: string;
  latitude: number;
  longitude: number;
  is_main: boolean;
  edit_count: number;
  forecast: number;
  created_at: string;
  updated_at: string;
}

interface ProfileState {
  profile: Profile | null;
  setProfile: (profile: Profile) => void;
  clearProfile: () => void;
}

export const useProfileStore = create<ProfileState>()(
  persist(
    (set) => ({
      profile: null,
      setProfile: (profile) => set({ profile }),
      clearProfile: () => set({ profile: null }),
    }),
    createSessionStoragePersist<ProfileState>(
      "profile",
      (state) => ({ profile: state.profile } as ProfileState)
    )
  )
);
